/* eslint-disable */
export default {
  loginButton: 'Anmelden',
  signupButton: 'Neuer Benutzer? Registrieren Sie sich.',
  version: 'Version',
} as const;

// @key: @#@"loginButton"@#@ @source: @#@"Sign In"@#@
// @key: @#@"signupButton"@#@ @source: @#@"New user? Sign Up"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
